import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
	PartnerMutationKeys,
	PartnerQueryKeys,
} from '../../../../manage-player/keys'
import {
	CreatePartnerPaymentRecordRequest,
	CreatePartnerPaymentRecordResponse,
} from '../../../../manage-player/type'
import { createPartnerPaymentRecord } from '../../../../manage-player/api/services'

interface UseMutationCreatePartnerPaymentRecordProps {
	partnerId: string
	payload: CreatePartnerPaymentRecordRequest
}

export default function useMutationCreatePartnerPaymentRecord(
	props?: UseBaseMutationOptions<
		CreatePartnerPaymentRecordResponse,
		UseMutationCreatePartnerPaymentRecordProps
	>,
) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationKey: [PartnerMutationKeys.CreatePartnerPaymentRecord],
		mutationFn: (params) =>
			createPartnerPaymentRecord(params.partnerId, params.payload),
		onSuccess: (_, variables) => {
			// Invalidate payment records query to refresh data
			queryClient.invalidateQueries({
				queryKey: [
					PartnerQueryKeys.GetPartnerPaymentRecords,
					variables.partnerId,
				],
			})
		},
		...props,
	})
}
